import { api } from './client'

export interface AppNotification {
  id: string
  type: string
  data: Record<string, unknown>
  read: boolean
  created_at: string
}

export function getNotifications(): Promise<AppNotification[]> {
  return api.get<AppNotification[]>('/notifications')
}

export function getUnreadCount(): Promise<{ count: number }> {
  return api.get<{ count: number }>('/notifications/unread-count')
}

export function markRead(id: string): Promise<void> {
  return api.post<void>(`/notifications/${id}/read`)
}

export function markAllRead(): Promise<void> {
  return api.post<void>('/notifications/read-all')
}
